








import {Component, Prop, Vue} from "vue-property-decorator";
import {LadingCareStore} from "@/modules/ladingcare/store";
import {LadingCare} from "@/interfaces/entity/ladingcare";
@Component({
  name: "LadingCareTableAction"
})
    export default class extends Vue{
    @Prop({required: true, type: Number})
    readonly ladingCareId!: number;
    
    get ladingCare(): LadingCare {
        return LadingCareStore.data[this.ladingCareId];
    }
    
    set ladingCare(value: LadingCare){
      LadingCareStore.data[this.ladingCareId] = value;
    }


}
